import axios from "@/api/index";
let method = 'GET';
/*添加地址信息或修改地址*/
export const addAddress=data=>axios.post('/register/systemsetting/addAddress',data)
/*背景图九宫格基础图片列表*/
export const backgroundImageNineGrids=data=>axios.get('/register/systemsetting/backgroundImageNineGrids',data)
/*删除地址信息*/
export const deletAddressById=data=>axios.post('/register/systemsetting/deletAddressById',data)
/*获取地址信息*/
export const getAddress=data=>axios.post('/register/systemsetting/getAddress',data)
/*获取企业认证的社会信用代码*/
export const getCompanyAuthInfo=data=>axios.post('/register/systemsetting/getCompanyAuthInfo',data)
/*获取用户个人信息*/
export const getCustomInfo=data=>axios.post('/register/systemsetting/getCustomInfo',data)
/*通过企友ID获取帮企网用户个人信息*/
export const getCustomInfoByQiyou=data=>axios.post('/register/systemsetting/getCustomInfoByQiyou',data)
/*获取token*/
export const getToken=data=>axios.post('/register/systemsetting/getToken',data)
/*获取用户身份认证信息*/
export const identityAuthInfo=data=>axios.post('/register/systemsetting/identityAuthInfo',data)
/*个人中心--修改用户简介*/
export const modifyUserIntroduction=data=>axios.post('/register/systemsetting/modifyUserIntroduction',data)
/*个人中心--修改用户昵称*/
export const modifyUserNickname=data=>axios.post('/register/systemsetting/modifyUserNickname',data)
/*个人中心--修改用户头像*/
export const modifyUserProfilePicture=data=>axios.post('/register/systemsetting/modifyUserProfilePicture',data)
/*保存用户个人信息*/
export const saveCustomInfo=data=>axios.post('/register/systemsetting/saveCustomInfo',data)
/*个人中心--保存背景图*/
export const saveCustomerBgImg=data=>axios.post('/register/systemsetting/saveCustomerBgImg',data)
/*新版--收货地址删除*/
export const setUpAddressDel=data=>axios.post('/register/systemsetting/setUpAddressDel',data)
/*新版--收货地址详情*/
export const setUpAddressInfo=data=>axios.post('/register/systemsetting/setUpAddressInfo',data)
/*新版--收货地址列表*/
export const setUpAddressList=data=>axios.post('/register/systemsetting/setUpAddressList',data)
/*新版--收货地址保存*/
export const setUpAddressSave=data=>axios.post('/register/systemsetting/setUpAddressSave',data)
/*修改默认地址*/
export const updateDefaultAdress=data=>axios.post('/register/systemsetting/updateDefaultAdress',data)
/*修改密码*/
export const updatePws=data=>axios.post('/register/systemsetting/updatePws',data)
/*校验旧密码*/
export const verifyOldPassword=data=>axios.post('/register/systemsetting/verifyOldPassword',data)
/*账号管理信息*/
export const accountManage=data=>axios.post('/order/personalCenter/accountManage',data)
/*首页分类列表*/
export const classificationSonsOnes=data=>axios.get('/home/rest/RevisionOneHome/classificationSonsOnes',data)
/*商务合作*/
export const personalBusinessCooperation=data=>axios.post('/home/restPlatformHome/personalBusinessCooperation',data)
/*职位分类二级列表*/
export const jobClassification=data=>axios.get('/home/rest/RevisionOnePersonalCenter/jobClassification',data)
/*身份认证列表*/
export const identityAuthenticationList=data=>axios.post('/home/rest/RevisionOnePersonalCenter/identityAuthenticationList',data)
/*银企直贷--社会信用代码获取公司信息*/
export const yqzdCompanyInfoBycode=data=>axios.post('/home/rest/RevisionOneGoods/yqzdCompanyInfoBycode',data)
/*验证企业/机构社会信用代码是否已被认证*/
export const verifyUSCCOdeIsAuthenticated=data=>axios.post('/home/rest/RevisionOnePersonalCenter/verifyUSCCOdeIsAuthenticated',data)
/*验证企业/机构名称是否已被认证*/
export const verifyNameIsAuthenticated=data=>axios.post('/home/rest/RevisionOnePersonalCenter/verifyNameIsAuthenticated',data)
/*数字工商证书--企业类型选择*/
export const choiceOfBusinessType=data=>axios.get('/home/rest/RevisionOnePersonalCenter/choiceOfBusinessType',data)
/*身份认证信息提交*/
export const reviewAuthenticationForEight=data=>axios.post('/home/rest/RevisionOnePersonalCenter/reviewAuthenticationForEight',data)